export enum WarehouseType {
  PetCompany = "0",
  Warehouse = "1",
  Shop = "2",
  Clinic = "3",
  ShopAndClinic = "4",
  Shipping = "5"
}
